import {
  Box,
  Button,
  Grid,
  Group,
  LoadingOverlay,
  MultiSelect,
  Select,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryPos,
} from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../_base/model/_base/SelectListItemBase";
import { sky_blue } from "../../../const/variables";
import { ComboboxItem } from "../../../model/ComboboxItem";
import { MessageResponse } from "../../../model/MessageResponse";
import { ReturnTechnicalExchangeEntityModel } from "../../../model/ReturnTechnicalExchange";
interface DecentralizeReductionEntity {
  id: string;
  typeAtuh: string | null;
  empid: number | null;
  listOrgId: string | null;
  createBy?: string;
  createDate?: Date;
  lastupdateBy?: string;
  lastupdateDate?: Date;
}
type Props = {
  fetchData: () => void;
  itemEdit?: ReturnTechnicalExchangeEntityModel; // Thêm itemEdit để nhận dữ liệu chỉnh sửa
};
const CreateReturnTechnicalExchange = ({ fetchData, itemEdit }: Props) => {
  const [dataBranchCodee, setDataBranchCodee] = useState<SelectListItemBase[]>(
    []
  ); // Danh sách chi nhánh
  const [dataEmployeeSelect, setDataEmployeeSelect] = useState<ComboboxItem[]>(
    []
  ); //danh sách nhân viên theo chi nhánh
  const [dataDepartment, setDataDepartment] = useState<SelectListItemBase[]>(
    []
  ); // Danh sách phòng ban
  const entity: DecentralizeReductionEntity = {
    id: "",
    typeAtuh: null,
    empid: null,
    listOrgId: null,
    createBy: "2",
    createDate: new Date(),
    lastupdateBy: "2",
    lastupdateDate: new Date(),
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      // typeAtuh: (value) =>
      //   value ? null : "Loại phân quyền xin giảm không được để trống",
      empid: (value) => (value ? null : "Nhân viên không được để trống"),
      listOrgId: (value) =>
        value ? null : "Danh sách phòng ban không được để trống",
    },
  });

  const handleCreateDecentralizeReduction = async (
    dataSubmit: DecentralizeReductionEntity
  ) => {
    open();
    try {
      console.log("dataSubmit", dataSubmit);
      let datahandle = {
        id: dataSubmit.id,
        // id: null,
        // typeAtuh:
        //   dataSubmit.typeAtuh !== null ? Number(dataSubmit.typeAtuh) : null,
        empid: dataSubmit.empid !== null ? Number(dataSubmit.empid) : null,
        listOrgId:
          dataSubmit.listOrgId === ""
            ? null
            : dataSubmit.listOrgId === "0"
            ? dataBranchCodee
                .filter(
                  (item: any) => item?.value !== null && item?.text !== null
                )
                .map((i: any) => i?.value?.toString())
                .join(",")
            : dataSubmit.listOrgId,
        createBy: dataSubmit.createBy,
      };
      let api = "/api/v1/AuthApproveKT/add-or-update";
      const response = await repositoryPos.post<
        MessageResponse<DecentralizeReductionEntity>
      >(`${api}`, datahandle);
      if (response && response.success) {
        await fetchData();
        modals.closeAll();
        setTimeout(() => {
          NotificationExtension.Success("Thêm mới thành công");
        }, 1000);
      } else {
        NotificationExtension.Fails(
          response?.message || "Có lỗi xảy ra. Vui lòng thử lại!"
        );
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      close();
    }
  };

  //  lấy danh sách chi nhánh
  const DataBranchCode = async () => {
    try {
      const response = await repositoryDelivery.get<
        MessageResponse<SelectListItemBase[]>
      >(`/api/v1/TblDmMasterOrg/get-select`);
      // console.log("response", response);
      if (response && response.success) {
        const data = response.data;
        setDataBranchCodee(data);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  console.log("dataBranchCodeeee", dataBranchCodee);
  console.log("form.getValues()", form.getValues());
  //  lấy danh sách phòng ban
  // const DataDepartmentCode = async () => {
  //   try {
  //     // const response = await repositoryPos.get<
  //     //   MessageResponse<SelectListItemBase[]>
  //     // >(`/api/v1/TblDepartment/get-select?branchId=0&isShipping=false`);
  //     const response = await repositoryPos.get<
  //       MessageResponse<SelectListItemBase[]>
  //     >(`/api/v1/TblDepartment/get-all`);

  //     console.log("response", response);
  //     if (response && response.success) {
  //       const data = response.data;
  //       setDataDepartment(data);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return;
  //   }
  // };
  //   lấy danh sách nhân viên theo chi nhánh
  const getDataEmployee = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmEmployee/get-select`
    );
    // console.log("res", res);
    if (res && res?.success) {
      setDataEmployeeSelect(
        res.data
          .filter(
            (item: any) =>
              item.att1 !== null && item.value !== null && item.text !== null
          )
          .map((i: any) => ({
            value: i.value,
            label: ` ${i.att1} - ${i.text}`,
          }))
      );
    }
  };
  useEffect(() => {
    const run = async () => {
      // await DataDepartmentCode();
      await DataBranchCode();
      await getDataEmployee();
    };
    run();
  }, []);

  useEffect(() => {
    if (itemEdit) {
      const fetchAndSet = async () => {
        if (itemEdit && dataBranchCodee && dataBranchCodee.length > 0) {
          // Xử lý listOrgId: nếu số lượng id bằng số lượng phòng ban thì set "0"
          let listOrgIdValue = itemEdit.listOrgId || null;
          if (listOrgIdValue) {
            const arr = listOrgIdValue.split(",").filter(Boolean);
            console.log("arr", arr, arr.length);
            const departmentIds = dataBranchCodee
              .filter(
                (item: any) => item?.value !== null && item?.text !== null
              )
              .map((item: any) => item.value?.toString());
            // Nếu tất cả phòng ban đều có trong arr thì set "0"
            if (arr && arr.length === departmentIds.length) {
              listOrgIdValue = "0";
              form.setFieldValue("listOrgId", "0");
            }
          }

          form.setValues({
            id: itemEdit.id,
            typeAtuh: itemEdit.typeAtuh?.toString() || null,
            empid: itemEdit.empid || null,
            listOrgId: listOrgIdValue,
            createBy: itemEdit.createBy || "2",
          });
        }
      };
      fetchAndSet();
    }
  }, [itemEdit, dataBranchCodee]);
  console.log("form.getValues()", form.getValues());
  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: DecentralizeReductionEntity) => {
          handleCreateDecentralizeReduction(e);
        })}
        style={{ position: "relative", maxWidth: "500px" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          {/* <Grid.Col span={12}>
            <Select
              label={"Loại phân quyền"}
              placeholder={"Nhập loại phân quyền"}
              withAsterisk
              key={`${form.getValues().typeAtuh}`}
              data={[
                { value: "1", label: "Cấp mức 1" },
                { value: "2", label: "Cấp mức 2" },
              ]}
              {...form.getInputProps("typeAtuh")}
            />
          </Grid.Col> */}
          {/* <Grid.Col span={12}>
            <MultiSelect
              placeholder="Chọn phòng ban"
              clearable
              searchable
              data={[
                { value: "-1", label: "Tất cả" },
                ...(Array.isArray(dataDepartment)
                  ? dataDepartment
                      .filter(
                        (item: any) =>
                          item?.name !== null && item?.departmentId !== null
                      )
                      .map((i: any) => ({
                        value: i?.departmentId?.toString(),
                        label: `[${i?.attribute1}] - ${i?.deparmentCode} - ${i?.name}`,
                      }))
                  : []),
              ]}
              withAsterisk
              label="Danh sách phòng ban"
              // key={`${form.getValues().listOrgId}`}
              value={
                form.getValues().listOrgId === "0"
                  ? ["-1"] // Khi giá trị là "0", hiển thị như đã chọn "Tất cả"
                  : form.getValues().listOrgId &&
                    form.getValues().listOrgId !== ""
                  ? (form.getValues().listOrgId ?? "").split(",")
                  : []
              }
              onChange={(value) => {
                if (value.includes("-1")) {
                  form.setFieldValue("listOrgId", "0");
                } else {
                  form.setFieldValue("listOrgId", value.join(","));
                }
              }}
              onBlur={() => form.validateField("listOrgId")}
              error={form.errors.listOrgId}
            />
          </Grid.Col> */}
          <Grid.Col span={12}>
            <MultiSelect
              placeholder="Chọn chi nhánh"
              clearable
              searchable
              data={[
                { value: "-1", label: "Tất cả" },
                ...(Array.isArray(dataBranchCodee)
                  ? dataBranchCodee
                      .filter(
                        (item: any) =>
                          item?.text !== null && item?.value !== null
                      )
                      .map((i: any) => ({
                        value: i?.value?.toString(),
                        label: `[${i?.value}] - ${i?.text}`,
                      }))
                  : []),
              ]}
              withAsterisk
              label="Danh sách chi nhánh"
              // key={`${form.getValues().listOrgId}`}
              value={
                form.getValues().listOrgId === "0"
                  ? ["-1"] // Khi giá trị là "0", hiển thị như đã chọn "Tất cả"
                  : form.getValues().listOrgId &&
                    form.getValues().listOrgId !== ""
                  ? (form.getValues().listOrgId ?? "").split(",")
                  : []
              }
              onChange={(value) => {
                if (value.includes("-1")) {
                  form.setFieldValue("listOrgId", "0");
                } else {
                  form.setFieldValue("listOrgId", value.join(","));
                }
              }}
              onBlur={() => form.validateField("listOrgId")}
              error={form.errors.listOrgId}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Select
              placeholder="Nhập mã hoặc tên nhân viên"
              data={dataEmployeeSelect}
              value={form.getValues().empid?.toString() || ""}
              searchable
              clearable
              label="Nhân viên"
              withAsterisk
              onClick={() => {
                if (dataEmployeeSelect.length === 0) {
                  getDataEmployee();
                }
              }}
              onChange={(value) => {
                form.setFieldValue("empid", value ? Number(value) : null);
              }}
              key={`${form.getValues().empid}`}
              onBlur={() => form.validateField("empid")}
              error={form.errors.empid}
              //   {...form.getInputProps("empid")}
            />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default CreateReturnTechnicalExchange;
